<template>
  <div>
    <!-- 注意！！テンプレートを変更した場合は、「RoundDownloadTemp」も変更！！ -->
    <template>
      <div class="overflow-auto" :class="isMobileDevice?'mobile-content':'pc-content'">

        <div class="flex justify-around">
          <div class="text-lg text-blue-800 font-bold flex items-center">
            <div class="ml-3">報告書</div>
            <span v-if="specialMode === 'only' && specialDef" class="special-tag">特別仕様&#12288;{{ specialDef.name }}</span>
            <span v-else-if="specialMode === 'both' && specialDef" class="special-tag">通常＋特別仕様</span>
          </div>

          <PrimaryButton text="閉じる" size="normal" class="mt-1 mr-1 ml-auto w-fit" @click="previous()" :disabled="processing" >
            <LoadingIcon v-if="processing" slot="before" class="h-4 w-4" />
          </PrimaryButton>
        </div>

        <div class="mt-5 w-11/12 mx-auto flex flex-wrap justify-center mb-12">
          <div class="text-gray-600 font-bold mr-auto info1 mt-5">
            得意先 : {{ list.clientName1 }}
            <div v-if="list.clientName2 && list.clientName2 != ''" class="font-normal ml-20 text-xs text-gray">（{{ list.clientName2 }}）</div>
          </div>
          <div class="text-gray-600 font-bold info2 mt-5">
            物件名 : {{ list.siteName }}
          </div>
          <div class="text-gray-600 font-bold info1 mt-5">
            巡回日 : {{ list.today }}
          </div>
          <div class="text-gray-600 font-bold info2 mt-5">
            巡回時間 : <span v-if="start!=''">{{ start }} ～ {{ end }}</span>
          </div>
          <div class="text-gray-600 font-bold info1 mt-5">
            <div v-if="canEdit">点検者 : <span class="text-red-600">「終了」ボタンを押した人</span></div>
            <div v-else>点検者 : {{ list.staff }}</div>
          </div>
          <div class="text-gray-600 font-bold info2 mt-5">
            位置情報 : {{ location }}
          </div>

          <!-- 特別仕様のある物件：開始の前に、どの報告書を作るか（初期値は両方） -->
          <div v-if="canEdit && start=='' && specialAvail" class="w-full mt-5 special-choice">
            <div class="text-sm font-bold text-pink-800 mb-1">作る報告書（この物件は得意先指定の「{{ specialAvail.def.name }}」があります）</div>
            <div class="flex seg">
              <button v-for="c in specialChoices" :key="c.value" type="button" :class="specialChoice === c.value ? 'seg-on' : ''" @click="specialChoice = c.value">{{ c.label }}</button>
            </div>
            <div class="text-xs text-gray-600 mt-1">選んでから「開始」を押してください。両方なら、通常の下に特別仕様の撮影欄が出ます。</div>
          </div>

          <div v-if="canEdit" class="flex mt-5 ml-auto mr-auto w-full">
            <PrimaryButton text="開始" size="normal" class="w-full mr-1" :class="start!=''?'bg-gray-400':''" v-if="start==''" @click="startBtn()" :disabled="processing" >
              <LoadingIcon v-if="processing" slot="before" class="h-4 w-4" />
            </PrimaryButton>
            <!-- <PrimaryButton text="キャンセル" size="normal" class="w-full mr-1 bg-red-400 hover:bg-red-500" v-if="start!=''" @click="cancelBtn()" :disabled="processing" >
              <LoadingIcon v-if="processing" slot="before" class="h-4 w-4" />
            </PrimaryButton> -->
            <PrimaryButton text="終了" size="normal" class="w-full ml-1" :class="start==''||end!=''?'bg-gray-400':''" :disabled="start==''||end!=''||processing" @click="endBtn()" >
              <LoadingIcon v-if="processing" slot="before" class="h-4 w-4" />
            </PrimaryButton>
          </div>

          <div v-if="completeBtn" class="flex mt-5 ml-auto mr-auto w-full">
            <PrimaryButton text="完了を再表示" size="normal" class="w-full mr-1 bg-teal-50 hover:bg-teal-50 edit text-teal-700" @click="reDisplay()" />
          </div>

          <div v-if="undoBtn" class="flex mt-5 ml-auto mr-auto w-full">
            <PrimaryButton text="完了を非表示に戻す" size="normal" class="w-full mr-1 bg-yellow-50 hover:bg-yellow-50 edit text-yellow-700 border-yellow-600" @click="undo()" />
          </div>
        </div>

        <div v-if="!start&&!processing" class="text-gray-800 font-bold w-fit mx-auto mt-5 animate-pulse">開始ボタンを押してください</div>

        <!-- 特別仕様の報告書（清掃前・清掃後）。「両方」は通常の上、「特別のみ」はこれだけ -->
        <div v-if="special && specialDef && (start || !canEditSpecial)" class="special">
          <div class="special-head">
            <div class="special-title">特別仕様<span class="special-title-sub">{{ specialDef.name }}</span></div>
          </div>

          <!-- 館銘板（表紙に載せる。清掃の箇所とは別に必須）。完了したら通常と同じく非表示
               ※ v-show だと Tailwind（important）の flex が display:none に勝って消えないので v-if -->
          <div v-if="!special.plateComplete || !completeBtn" class="flex justify-center">
            <div class="special-card special-plate" :class="special.plateComplete ? 'special-done' : ''">
              <div class="special-card-head">
                <span class="special-no">館</span>
                <span class="special-name-view">館銘板<span class="text-xs font-normal text-red-700 ml-2">必須（表紙に載せます）</span></span>
                <span v-if="special.plateComplete" class="special-check"><Icon iconName="CheckCircle" class="w-5 h-5" /></span>
              </div>
              <!-- 編集 -->
              <div v-if="canEditSpecial" class="special-photo" :class="special.plateUrl ? 'has-photo' : ''">
                <span class="special-kind">館銘板</span>
                <div v-if="!special.plateUrl" class="special-empty">
                  <LoadingIcon v-if="specialSaving === 'plate'" class="h-11 w-11" />
                  <template v-else>
                    <Icon iconName="Camera" class="h-11 w-11" />
                    <div class="mt-2">カメラ起動</div>
                  </template>
                </div>
                <input class="file-type" type="file" accept="image/*" capture="environment" @change="specialPlatePhoto($event)" />
                <img v-if="special.plateUrl" :src="special.plateUrl" class="w-full h-full object-contain">
              </div>
              <!-- 参照 -->
              <div v-else class="special-photo">
                <span class="special-kind">館銘板</span>
                <a v-if="special.plateUrl" :href="special.plateUrl" data-lightbox="specialPlate" class="w-full h-full block">
                  <img :src="special.plateUrl" class="w-full h-full object-contain">
                </a>
              </div>
              <!-- 完了ボタン（通常と同じ） -->
              <div v-if="canEditSpecial" class="mt-2">
                <PrimaryButton :text="processing?'':'完了'" class="text-blue-800 bg-blue-50 border border-blue-800 w-full" @click="completePlate()" :disabled="processing">
                  <LoadingIcon v-if="processing" slot="before" class="h-4 w-4 text-blue-600" />
                </PrimaryButton>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap justify-center">
            <!-- 完了した箇所は通常と同じく非表示（「完了を再表示」で戻る） -->
            <div v-for="(it, i) in special.items" v-show="!it.complete || !completeBtn" :key="'sp' + it.sortNo" class="special-card" :class="it.complete ? 'special-done' : ''">
              <!-- 箇所名 -->
              <div class="special-card-head">
                <span class="special-no">{{ it.sortNo }}</span>
                <input
                  v-if="canEditSpecial"
                  type="text"
                  class="special-name"
                  :class="!it.item ? 'special-name-empty' : ''"
                  placeholder="箇所名を入力（必須）"
                  v-model="it.item"
                  @change="saveSpecialItem(it)"
                />
                <span v-else class="special-name-view">{{ it.item }}</span>
                <span v-if="it.complete" class="special-check"><Icon iconName="CheckCircle" class="w-5 h-5" /></span>
              </div>

              <!-- 清掃前・清掃後 -->
              <div class="flex" style="gap: 8px">
                <div v-for="kind in ['before', 'after']" :key="kind" class="flex-1 min-w-0">
                  <!-- 編集 -->
                  <div v-if="canEditSpecial" class="special-photo" :class="[kind, it[kind + 'Url'] ? 'has-photo' : '']">
                    <span class="special-kind" :class="kind">{{ kind === 'before' ? '清掃前' : '清掃後' }}</span>
                    <div v-if="!it[kind + 'Url']" class="special-empty">
                      <LoadingIcon v-if="specialSaving === it.sortNo + kind" class="h-11 w-11" />
                      <template v-else>
                        <Icon iconName="Camera" class="h-11 w-11" />
                        <div class="mt-2">カメラ起動</div>
                      </template>
                    </div>
                    <input class="file-type" type="file" accept="image/*" capture="environment" @change="specialPhoto(i, kind, $event)" />
                    <img v-if="it[kind + 'Url']" :src="it[kind + 'Url']" class="w-full h-full object-contain">
                  </div>
                  <!-- 参照 -->
                  <div v-else class="special-photo" :class="kind">
                    <span class="special-kind" :class="kind">{{ kind === 'before' ? '清掃前' : '清掃後' }}</span>
                    <a v-if="it[kind + 'Url']" :href="it[kind + 'Url']" :data-lightbox="'special' + i" class="w-full h-full block">
                      <img :src="it[kind + 'Url']" class="w-full h-full object-contain">
                    </a>
                  </div>
                </div>
              </div>

              <!-- ひと言（Excel の欄に収まる 40 文字まで） -->
              <input
                v-if="canEditSpecial"
                type="text"
                maxlength="40"
                placeholder="特筆することがある場合のみここに記入（40文字まで）"
                class="special-note"
                :class="it.note ? 'has-note' : ''"
                v-model="it.note"
                @change="saveSpecialItem(it)"
              />
              <div v-else-if="it.note" class="special-note-view">{{ it.note }}</div>

              <!-- 完了ボタン（通常と同じ） -->
              <div v-if="canEditSpecial" class="mt-2">
                <PrimaryButton :text="processing?'':'完了'" class="text-blue-800 bg-blue-50 border border-blue-800 w-full" @click="completeSpecialItem(it)" :disabled="processing">
                  <LoadingIcon v-if="processing" slot="before" class="h-4 w-4 text-blue-600" />
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>

        <!-- 両方のときは、ここから下が通常の報告書 -->
        <div v-if="specialMode==='both'&&(start||!canEdit)" class="normal-head">通常の報告書</div>

        <div v-if="start&&canEdit&&specialMode!=='only'" class="text-gray-600 font-bold w-fit mx-auto mt-5 mb-8">
          <div>特筆することがある場合、写真の下の記入欄にご記入ください。</div>
          <div>記載がある場合は、提出用のExcelに表示されます。</div>
          <div class="mt-5 text-red-600 text-xs">掃き清掃の写真は必ず入れてください。</div>
          <div class="mt-5 text-red-600 text-xs">写真を見ただけでどこの箇所（階段や手すりなど）か分かるように撮影してください。</div>
          <div class="mt-1 text-red-600 border-b border-red-700 w-fit text-xs">どこの箇所か分からないくらいアップで撮るのはおやめください。</div>
          <div class="mt-5 text-blue-700 text-sm">※「写真並替をON」の場合、写真をドラッグ＆ドロップで写真の入れ替え可能</div>
        </div>

        <div v-if="textRequire&&specialMode!=='only'" class="text-gray-600 font-bold w-fit mx-auto my-5">過去フォーマットご希望の物件です。撮影対象箇所がExcelに表示されます。</div>
        <div v-else-if="!canEdit&&specialMode!=='only'" class="text-gray-600 font-bold w-fit mx-auto my-5">撮影対象箇所（青文字）はExcelには表示されません。</div>

        <!-- 通常の報告書（特別仕様だけのときは出さない） -->
        <div v-if="start&&specialMode!=='only'" class="flex flex-wrap justify-center">
          <div v-for="(row, i) in checkList.items" :key="'r'+i">
            <div v-if="(!row.complete || !completeBtn)">
              <div class="w-300px mb-10 mx-10">
                <!-- No -->
                <div v-if="canEdit" class="text-blue-700 font-bold">
                  <span>{{ row.sortNo }}.</span>
                  <span v-if="!row.classification" class="text-red-700 font-bold text-sm pl-3">＊撮影対象箇所を入力してください</span>
                </div>

                <!-- 写真の内容 -->
                <!-- 編集画面 -->
                <div v-if="canEdit">
                  <WmsSuggestInput
                    id="classific"
                    :name="'classification' + i"
                    :embed="true"
                    displayField="val"
                    :dynamic="false"
                    :incrementalSearch="false"
                    :selectionItems="classificationList"
                    class="embed border border-gray-400"
                    v-model="row.classification"
                    placeholder="撮影対象箇所は入力必須です"
                    :clearable="true"
                    @selected="temporarilyRegister('item', row, $event, i, 'classification')"
                  />
                </div>
                <!-- 参照画面 -->
                <div v-else>
                  <div class="font-bold text-sm text-blue-700">
                    <span>{{ row.sortNo }}.</span> <span class="pl-3">{{ row.classification }}</span>
                  </div>
                </div>

                <!-- 写真 -->
                <div class="my-1" :class="row.photo&&row.photo.length>1?'':'h-60'">
                  <!-- 編集画面 -->
                  <div v-if="canEdit" :draggable="draggablePhoto" @dragstart="dragStart(row)" @drop="drop(row)" @drop.prevent @dragover.prevent class="border border-gray-400 h-full text-gray-700 font-bold text-center relative">
                    <div v-if="(!row.photo||!row.photo.length)&&!draggablePhoto" class="absolute position-center">
                      <LoadingIcon v-if="processing" slot="before" class="h-10 w-10 m-auto" />

                      <div v-else class="flex">
                        <div :class="row.sortNo>=5?'-left-14 absolute whitespace-nowrap':''"><Icon iconName="Camera" slot="before" class="h-10 w-10 m-auto" />カメラ起動</div>
                        <div v-if="row.sortNo>=5" class="absolute left-14 whitespace-nowrap"><Icon iconName="FolderDownload" slot="before" class="h-10 w-10 m-auto" />写真添付</div>
                      </div>
                    </div>
                    <div v-if="(!row.photo||!row.photo.length)&&draggablePhoto" class="absolute position-center2 text-xs">
                      <LoadingIcon v-if="processing" slot="before" class="h-10 w-10 m-auto" />
                      <Icon v-else-if="!processing" iconName="ExclamationCircle" slot="before" iconType="outline" class="h-10 w-10 m-auto text-blue-700" />
                      「写真並替ON/OFF」をタップしてOFFにすると写真添付可能
                    </div>
                    <input v-if="!draggablePhoto" :class="row.sortNo>=5?'file-type2':'file-type'" type="file" accept="image/*" capture="environment" @change="imageToBase64(i, $event)" />
                    <input v-if="!draggablePhoto&&row.sortNo>=5" class="file-type3" type="file" accept="image/*" @change="imageToBase64(i, $event, true)" />

                    <div class="drag-photo p-2 text-sm rounded-tr text-white" :class="draggablePhoto?'bg-indigo-500':'bg-gray-400'" @click="draggablePhoto=!draggablePhoto">写真並替ON/OFF</div>
                    <!-- 添付した写真 -->
                    <div v-if="row.photo&&row.photo.length" style="width: 100%; height: 100%;">
                      <img :src="row.photo[0]" class="w-full h-full object-contain">
                    </div>
                  </div>

                  <!-- 参照画面 -->
                  <div v-else class="border border-gray-300 h-full w-full text-center">
                    <div v-if="row.photo" class="w-full h-full">
                      <div v-for="(p, j) in row.photo" :key="'p'+j" class="w-full h-full">
                        <!-- 写真1枚（新仕様） -->
                        <div v-if="row.photo.length==1" class="w-full h-full">
                          <a :href="p" :data-lightbox="'item' + i" class="w-full h-full">
                            <img :src="p" class="w-full h-full object-contain">
                          </a>
                        </div>
                        <!-- 過去仕様 -->
                        <div v-else>
                          <a :href="p" :data-lightbox="'item' + i" class="w-full h-full">
                            <img :src="p">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 特記事項 -->
                <div>
                  <input
                    v-if="canEdit"
                    type="text"
                    placeholder="特筆することがある場合のみここに記入"
                    class="px-1 py-2 border border-gray-400 rounded-b w-full"
                    v-model="row.cleaningText"
                  />
                  <div v-else class="px-1 py-2">
                    {{ row.cleaningText }}
                  </div>
                </div>
                <!-- 完了ボタン -->
                <div class="m-1">
                  <PrimaryButton v-if="canEdit" :text="processing?'':'完了'" class="text-blue-800 bg-blue-50 border border-blue-800 w-full" @click="complete(i)" :disabled="processing" >
                    <LoadingIcon v-if="processing" slot="before" class="h-4 w-4 text-blue-600" />
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-transparent">{{reload}}</div>
      </div>
    </template>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import * as image from '@libs/image'
import { RLS_OLD_FORMAT, RLS_SPECIAL_FORMATS } from '@libs/constants'
import moment from 'moment'
import * as logManager from '@managers/logManager'

// 注意！！テンプレートを変更した場合は、「RoundDownloadTemp」も変更！！

const ITEMS = {
    // 区分
    classification: '',
    // 特記事項
    cleaningText: '',
    // 写真
    photo: [],
    // 完了ボタン
    complete: false,
  }

export default {
  components: {
    Icon,
    PrimaryButton,
    LoadingIcon,
    WmsSuggestInput
  },

  props: {
    // 区分名
    typeName: {
      type: String,
      default: null
    },
    // 区分（1：品質巡回、2：巡回清掃、3：定期清掃）
    type: {
      type: Number,
      default: null
    },
    // 親画面（予定一覧）
    routerName: {
      type: String,
      default: null
    },
    // 物件位置情報
    siteLocation: {
      type: Object
    },
    // RLS
    rls: {
      type: Object
    },
  },

  data() {
    return {
      // 表示対象予定詳細情報
      target: {},
      // 表示データ
      list: [],
      // 開始時間
      start: '',
      // 終了時間
      end: '',
      // 位置情報
      location: '',
      // チェック項目
      checkList: {
        items: [
          utils.clone(ITEMS)
        ],
        memo: ''
      },
      // 写真並べ替え
      draggablePhoto: false,
      // 並べ替え対象データ
      dragItem: {},
      // 編集できるか
      canEdit: true,
      // 処理中
      processing: false,
      processingText: 'Loading...',
      // 写真更新
      reload: 0,
      // 完了ボタンが押されたか
      completeBtn: false,
      // 非表示の該当なしトグル
      toggleNA: false,
      // 完了を非表示ボタン活性
      undoBtn: false,
      // クレーム対応(クレーム対応はない)
      claim: false,
      // 清掃箇所リスト
      classificationList: [
        { val: '建物' },
        { val: '敷地内' },
        { val: '廊下' },
        { val: '階段' },
        { val: '手すり' },
        { val: 'ゴミ置き場' },
        { val: '駐輪場' },
        { val: '駐車場' },
        { val: '備品類' }
      ],
      // 状況リスト
      itemList: [
        { val: '掃き清掃致しました。' },
        { val: '拭き清掃致しました。' },
        { val: 'モップ掛け致しました。' },
        { val: '水洗い致しました。' },
        { val: '除草剤致しました。' },
        { val: '除塵致しました。' },
        { val: '放置物があります。' },
        { val: 'チラシ回収致しました。' },
        { val: '点灯確認致しました。' }
      ],
      // 過去のフォーマット指定なので、項目入力必須
      textRequire: false,

      // 特別仕様（得意先指定の書式。清掃前・清掃後）
      // none：無し、both：通常の下に特別仕様も出す、only：この行は特別仕様の行で特別仕様だけ
      specialMode: 'none',
      // 特別仕様の報告書（rlsSpecial/get の結果：schedule・result・temporary・items）
      special: null,
      // 写真を保存中の箇所（sortNo + kind）
      specialSaving: null,
      // 物件の特別仕様（通常の行で、まだ答えを記録していないときだけ。{ format, def }）
      specialAvail: null,
      // 開始の前に選ぶ「作る報告書」（1：通常のみ、2：特別仕様のみ、3：両方。初期値は両方）
      specialChoice: 3
    }
  },

  async created() {
    // 巡回清掃にクレーム対応はなし
    this.claim = false
    // booleanでない場合（リロードなどで URL から開き直したとき）は前の画面へ戻るだけ。この画面の読み込みは続けない
    if (typeof this.$route.query.claim != 'boolean') {
      this.previous(true)
      return
    }
    await this.getTarget()
  },

  computed: {
    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * 管理者権限あり
     */
    isAdmin() {
      let auth = this.$store.getters.auth
      if (auth && auth.adminAuth) {
        return true
      }
      return false
    },

    /**
     * ログインユーザー名
     */
    user() {
      return utils.deleteKana(this.$store.getters.user.user_name)
    },

    /**
     * 特別仕様の定義（表示名・箇所の数・説明）
     */
    specialDef() {
      if (!this.special || !this.special.schedule || !this.special.schedule.specialFormat) {
        return null
      }
      return RLS_SPECIAL_FORMATS[this.special.schedule.specialFormat] || null
    },

    /**
     * 特別仕様を編集できるか（まだ終了していない）
     */
    canEditSpecial() {
      return !!(this.special && !this.special.result)
    },

    /**
     * 「作る報告書」の切り替えの選択肢
     */
    specialChoices() {
      if (!this.specialAvail) {
        return []
      }
      const def = this.specialAvail.def
      return [
        { value: 1, label: '通常のみ' },
        { value: 2, label: `特別仕様のみ（${def.itemCount * 2}枚）` },
        { value: 3, label: '両方' }
      ]
    },

  },

  methods: {
    /**
     * 表示するデータ取得
     */
    async getTarget() {
      if (this.$route.query.scheduleId) {
        this.processing = true
        this.processingText = 'Loading...'

        // スケジュールIDに紐づくデータを取得
        let schedule = await backend.searchData('patrolSchedule/getById', { id: this.$route.query.scheduleId })

        if (schedule.data.data && schedule.data.data.length) {
          this.target = schedule.data.data[0]
        } else {
          this.processing = false
          await dialogs.showErrorDialog('エラー', '対象データがありません。')
          return
        }
        this.processing = false

        this.list = this.target
        this.list.today = moment().format('YYYY/MM/DD')

        // 特別仕様の行（この行は特別仕様だけ）
        if (this.target.specialFormat) {
          this.specialMode = 'only'
          await this.loadSpecial(this.target.id)
          this.processing = false
          return
        }

        // 通常の行。未完了で答えがまだなら、物件に特別仕様があるか見て、開始の前の切り替えを出す
        if (!this.target.completionDate && !this.target.specialChoice) {
          await this.checkSpecialAvail()
        }
        // 「両方」なら相手の特別の行も出す
        if (Number(this.target.specialChoice) === 3 && this.target.specialPairId) {
          this.specialMode = 'both'
          await this.loadSpecial(this.target.specialPairId)
        }

        // 過去フォーマット指定で文言必須か判定
        this.isRequireText()

        // 巡回清掃済み
        if (this.target.completionDate && this.target.completionDate != '') {
          this.canEdit = false

          // データ取得
          this.processing = true
          this.processingText = 'Loading...'
          const compR = await backend.searchData('patrolResult/getByPatrolScheduleId', { patrolScheduleId: this.target.id, clientCode: this.target.clientCode, siteCode: this.target.siteCode, scheduledDate: moment(this.target.scheduledDate).format('YYYY-MM-DD'), type: this.type, claim: this.claim, spot: false, getPhoto: 's3Url' })
          if (compR.data && compR.data.data) {
            this.setData(compR.data.data)
          }
          this.processing = false

        // 巡回清掃まだ
        } else {
          this.canEdit = true
          // 途中保存があり、途中から行う場合
          if (await this.temporary()) {
            return
          }

          await this.initCheck()
        }
        this.processing = false
      }
    },

    // ---------- 特別仕様 ----------

    /**
     * 物件に特別仕様があるか（あれば開始の前に「作る報告書」の切り替えを出す。初期値は両方）
     * API: rls/getSpecial
     */
    async checkSpecialAvail() {
      this.specialAvail = null
      this.specialChoice = 3
      const res = await backend.searchData('rls/getSpecial', { siteCode: this.target.siteCode })
      const sp = res.data && res.data.data
      if (!sp || !sp.format || !RLS_SPECIAL_FORMATS[sp.format]) {
        return
      }
      this.specialAvail = { format: sp.format, def: RLS_SPECIAL_FORMATS[sp.format] }
    },

    /**
     * 開始を押したときに「作る報告書」の答えを記録し、要る行を作る
     * API: rlsSpecial/choose
     * @returns 「特別仕様のみ」で特別の行へ開き直したら true
     */
    async applySpecialChoice() {
      if (!this.specialAvail) {
        return false
      }
      const choice = this.specialChoice
      const r = await backend.postData('rlsSpecial/choose', { id: this.target.id, choice, format: this.specialAvail.format, user: this.$store.getters.user.id })
      const result = r.data && r.data.data
      this.specialAvail = null
      if (choice === 2 && result && result.specialId) {
        // 特別の行で開き直す（RLS が作った空の行を転用したときは同じ id）
        if (Number(result.specialId) !== Number(this.target.id)) {
          await this.$router.replace({ name: this.$route.name, query: { ...this.$route.query, scheduleId: String(result.specialId) }, params: this.$route.params })
        }
        this.initData()
        await this.getTarget()
        return true
      }
      if (choice === 3 && result) {
        this.target.specialChoice = 3
        this.target.specialPairId = result.specialId
        this.specialMode = 'both'
        await this.loadSpecial(result.specialId)
      } else {
        this.target.specialChoice = choice
      }
      return false
    },

    /**
     * 特別仕様の報告書を取る（開始時刻・位置は途中保存から）
     * API: rlsSpecial/get
     */
    async loadSpecial(scheduleId) {
      const res = await backend.searchData('rlsSpecial/get', { patrolScheduleId: scheduleId, user: this.$store.getters.user.id })
      const sp = res.data && res.data.data
      if (!sp) {
        this.special = null
        return
      }
      // あとから値を入れる項目は、読み込み時にキーをそろえておく（無いと Vue 2 が変更を追えない）
      if (sp.plateUrl === undefined) {
        sp.plateUrl = ''
      }
      if (sp.plateComplete === undefined) {
        sp.plateComplete = false
      }
      for (const it of sp.items) {
        if (it.complete === undefined) {
          it.complete = false
        }
      }
      this.special = sp
      // 完了した箇所（館銘板も）があれば「完了を再表示」ボタンを出す（通常と同じ）
      if (!sp.result && (sp.plateComplete || sp.items.some((it) => it.complete))) {
        this.completeBtn = true
      }
      // 特別仕様だけの行は、開始・終了・位置もここから
      if (this.specialMode === 'only') {
        if (sp.result) {
          this.canEdit = false
          this.start = sp.result.startTime || ''
          this.end = sp.result.endTime || ''
          this.location = sp.result.location || ''
          if (sp.result.completionDate) {
            this.list.today = moment(sp.result.completionDate).format('YYYY/MM/DD')
          }
        } else {
          this.canEdit = true
          if (sp.temporary && sp.temporary.startTime) {
            this.start = sp.temporary.startTime
            this.location = sp.temporary.location || ''
          }
        }
      }
    },

    /**
     * 特別仕様の開始（途中保存に控える）
     * API: rlsSpecial/start
     */
    async startSpecial() {
      if (!this.special || !this.canEditSpecial) {
        return
      }
      await backend.postData('rlsSpecial/start', { patrolScheduleId: this.special.schedule.id, siteCode: this.target.siteCode, startTime: this.start, location: this.location, insertUser: this.$store.getters.user.id })
    },

    /**
     * 特別仕様の写真（撮った瞬間に保存。撮り直しは上書き）
     * API: rlsSpecial/savePhoto
     * @param i 箇所のインデックス
     * @param kind before／after
     */
    async specialPhoto(i, kind, event) {
      const file = event.target.files && event.target.files[0]
      if (!file) {
        return
      }
      const it = this.special.items[i]
      this.specialSaving = it.sortNo + kind
      try {
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader()
          reader.onload = () => {
            const img = new Image()
            img.src = reader.result
            img.onload = () => resolve(image.compressImage(img, false, 854, 0.8))
          }
          reader.readAsDataURL(file)
        })
        const res = await backend.postData('rlsSpecial/savePhoto', {
          patrolScheduleId: this.special.schedule.id,
          siteCode: this.target.siteCode,
          sortNo: it.sortNo,
          kind,
          item: it.item,
          base64,
          user: this.$store.getters.user.id
        })
        it[kind + 'Url'] = res.data.data
      } catch (e) {
        console.log(e)
        await dialogs.showErrorDialog('写真', '写真を保存できませんでした。もう一度撮ってください。')
      } finally {
        this.specialSaving = null
        event.target.value = ''
        this.reload++
      }
    },

    /**
     * 館銘板の写真（撮った瞬間に保存。撮り直しは上書き）
     * API: rlsSpecial/savePlatePhoto
     */
    async specialPlatePhoto(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) {
        return
      }
      this.specialSaving = 'plate'
      try {
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader()
          reader.onload = () => {
            const img = new Image()
            img.src = reader.result
            img.onload = () => resolve(image.compressImage(img, false, 854, 0.8))
          }
          reader.readAsDataURL(file)
        })
        const res = await backend.postData('rlsSpecial/savePlatePhoto', {
          patrolScheduleId: this.special.schedule.id,
          siteCode: this.target.siteCode,
          base64,
          user: this.$store.getters.user.id
        })
        this.special.plateUrl = res.data.data
      } catch (e) {
        console.log(e)
        await dialogs.showErrorDialog('写真', '写真を保存できませんでした。もう一度撮ってください。')
      } finally {
        this.specialSaving = null
        event.target.value = ''
        this.reload++
      }
    },

    /**
     * 館銘板の完了ボタン（写真があれば完了にして非表示）
     * API: rlsSpecial/completePlate
     */
    async completePlate() {
      if (this.start == '') {
        await dialogs.showErrorDialog('開始ボタン', '開始ボタンを押してください。')
        return
      }
      if (!this.special.plateUrl) {
        await dialogs.showErrorDialog('完了できません', '館銘板の写真を撮ってください。')
        return
      }
      this.special.plateComplete = true
      this.undo()
      this.reload++
      this.processing = true
      try {
        await backend.postData('rlsSpecial/completePlate', { patrolScheduleId: this.special.schedule.id, siteCode: this.target.siteCode, complete: true, user: this.$store.getters.user.id })
      } catch (e) {
        console.log(e)
      }
      this.processing = false
    },

    /**
     * 特別仕様の箇所名・ひと言を保存
     * API: rlsSpecial/saveItem
     */
    async saveSpecialItem(it) {
      try {
        await backend.postData('rlsSpecial/saveItem', { patrolScheduleId: this.special.schedule.id, siteCode: this.target.siteCode, sortNo: it.sortNo, item: it.item, note: it.note, complete: !!it.complete, user: this.$store.getters.user.id })
      } catch (e) {
        console.log(e)
      }
    },

    /**
     * 特別仕様の 1 箇所のチェック（箇所名・清掃前・清掃後）
     * @param it 箇所
     * @param title エラーの題
     */
    async validateSpecialItem(it, title) {
      if (!it.item) {
        await dialogs.showErrorDialog(title, `特別仕様 ${it.sortNo} の箇所名を入力してください。`)
        return false
      }
      if (!it.beforeUrl) {
        await dialogs.showErrorDialog(title, `特別仕様【${it.item}】の清掃前の写真がありません。`)
        return false
      }
      if (!it.afterUrl) {
        await dialogs.showErrorDialog(title, `特別仕様【${it.item}】の清掃後の写真がありません。`)
        return false
      }
      return true
    },

    /**
     * 特別仕様の箇所の完了ボタン（通常と同じく、完了した箇所は非表示にする）
     */
    async completeSpecialItem(it) {
      if (this.start == '') {
        await dialogs.showErrorDialog('開始ボタン', '開始ボタンを押してください。')
        return
      }
      if (!await this.validateSpecialItem(it, '完了できません')) {
        return
      }
      it.complete = true
      this.undo()
      this.reload++
      this.processing = true
      await this.saveSpecialItem(it)
      this.processing = false
    },

    /**
     * 特別仕様の終了前のチェック（全箇所が完了していて、箇所名と前後の写真がそろっているか）
     */
    async validateSpecial() {
      if (!this.special.plateUrl) {
        await dialogs.showErrorDialog('終了できません', '特別仕様の「館銘板」の写真がありません。')
        return false
      }
      if (!this.special.plateComplete) {
        await dialogs.showErrorDialog('終了できません', '特別仕様の「館銘板」の完了ボタンが押されていません。')
        return false
      }
      for (const it of this.special.items) {
        if (!it.complete) {
          const title = it.item ? `特別仕様【${it.item}】` : `特別仕様 ${it.sortNo}`
          await dialogs.showErrorDialog('終了できません', `${title} の完了ボタンが押されていません。`)
          return false
        }
        if (!await this.validateSpecialItem(it, '終了できません')) {
          return false
        }
      }
      return true
    },

    /**
     * 特別仕様の終了（結果の行を作る）
     * API: rlsSpecial/complete
     */
    async completeSpecial() {
      const save = {
        patrolScheduleId: this.special.schedule.id,
        siteCode: this.target.siteCode,
        completionDate: this.list.today,
        startTime: this.start,
        endTime: this.end,
        location: this.location,
        insertUser: this.$store.getters.user.id
      }
      const items = this.special.items.map((it) => ({ sortNo: it.sortNo, item: it.item, note: it.note }))
      await backend.postData('rlsSpecial/complete', { save, items, staff: this.user, isRls: this.$route.query.rls, rls: this.rls })
    },

    /**
     * 保存している結果をセット
     */
    setData(r) {
      if (r.result.length) {
        let result = r.result[0]
        this.start = result.startTime
        if (result.endTime) {
          this.end = result.endTime
        } else {
          this.end = ''
        }
        if (result.completionDate) {
          this.list.today = moment(result.completionDate).format('YYYY/MM/DD')
        }
        this.location = result.location
        this.point = result.getPoint
        this.totalPoint = result.totalPoint
      }
      if (r.item) {
        for (let i = 0; i < r.item.length; i++) {
          const row = r.item[i]
          for (let j = 0; j < row.photo.length; j++) {
            // 写真は S3 の期限付き URL（文字列）。かなり昔の DB 直保存の分だけバッファーで来る
            if (row.photo[j] && typeof row.photo[j] !== 'string') {
              row.photo[j] = image.bufferToDataUrl(row.photo[j])
            }
          }
        }
        this.checkList.items = r.item
      }
    },

    /**
     * 途中保存を取得
     */
    async temporary() {
      const temporaryS =  await backend.searchData('patrolTemporarySaving/isSaving', { patrolScheduleId: this.target.id })
      if (temporaryS && temporaryS.data && temporaryS.data.data.length) {
        await dialogs.showInfoDialog('途中保存データあり', '途中保存しているデータがあるので表示します。')

        // 途中から再開する場合
        // if (dialogR == 'YES') {
          this.processing = true
          this.processingText = 'Loading...'
          let temporaryR = []

          let param = { clientCode: this.target.clientCode, siteCode: this.target.siteCode, patrolScheduleId: this.target.id, type: this.type, claim: this.claim, spot: false, getPhoto: 's3Url' }

          temporaryR = await backend.searchData('patrolTemporarySaving/getByPatrolScheduleId', param)

          // 完了を表示ボタンを出す
          if (temporaryR.data.data.item && temporaryR.data.data.item.length) {
            for (let i = 0; i < temporaryR.data.data.item.length; i++) {
              const it = temporaryR.data.data.item[i]
              if (it.complete) {
                this.completeBtn = true
                break
              }
            }
          }

          this.setData(temporaryR.data.data)
          this.processing = false

          return true

        // 最初からやり直す場合
        // } else {
        //   // データを削除
        //   await backend.deleteDataByKey('patrolResult/deleteByPatrolScheduleId', { key: this.target.id, sub: this.$route.query.sub })
        //   return false
        // }
      }
      return false
    },

    /**
     * 点検前の点検表セット
     */
    async initCheck() {
      this.processing = true
      this.processingText = 'Loading...'

      // 物件コードが変更になっていないか確認
      let isChangeCode = await backend.searchData('checkListHistory/isChangeCode', { siteCode: this.target.siteCode, type: this.type, claim: this.claim, siteAddress: this.target.siteAddress, siteName: this.target.siteName, spot: false })
      if (isChangeCode.data && isChangeCode.data.data && isChangeCode.data.data.result) {
        this.processing = false
        const inf = isChangeCode.data.data.info
        const msg = `
          前回完了日：${inf.completionDate}
          物件名：${inf.siteName}
          住所：${inf.siteAddress}
        `
        const chagneCode = await dialogs.showConfirmDialog('物件コードが変わった可能性があります。', '過去の物件コードと新しい物件コードを一致させますか？\r\n新しい物件コードと一致させると過去のデータが引き継がれます。\r\n\r\n【同じと思われる過去のデータ】' + msg)
        this.processing = true
        // 過去の物件コードを変更する
        if (chagneCode == 'YES') {
          try {
            await backend.postData('checkListHistory/changingCode', { newSiteCode: this.target.siteCode, oldSiteCode: inf.siteCode, type: this.type, claim: this.claim, id: this.target.id, spot: false })
            //ログ出力
            logManager.recording(this, logManager.Loglevel.INFO, this.typeName, '物件コード変更', this.typeName + '（物件名：' + inf.siteName + '、物件コード：' + inf.siteCode + '、完了日：'+ inf.completionDate + '以前全て、予定ID：'+ inf.id +'以前全て）を（物件コード：' + this.target.siteCode + '）に変更しました。')
          } catch (error) {
            // 前の画面に戻る
            this.previous()
            this.initData()
          }
        }
      }

      // 点検表
      let cheR = await backend.searchData('checkListByClient/getByClientCode', { clientCode: this.target.clientCode, siteCode: this.target.siteCode, type: this.type })
      if (cheR.data && cheR.data.data && cheR.data.data.length) {
        this.checkList.items = cheR.data.data
      }
      this.processing = false
    },

    /**
     * 初期化
     */
    initData() {
      // 表示データ
      this.list = []
      // 開始時間
      this.start = ''
      // 終了時間
      this.end = ''
      // チェック項目
      this.checkList = {
        items: [
          utils.clone(ITEMS)
        ],
        memo: ''
      }
      // 編集できるか
      this.canEdit = true
      // 処理中
      this.processing = false
      // 完了ボタン
      this.completeBtn = false
      // 非表示の該当なしトグル
      this.toggleNA = false
      // 完了を非表示ボタン活性
      this.undoBtn = false
      // 特別仕様
      this.specialMode = 'none'
      this.special = null
      this.specialSaving = null
      this.specialAvail = null
      this.specialChoice = 3
    },

    /**
     * 開始ボタン
     */
    async startBtn() {
      this.processing = true
      // 現在地と物件の位置を比較
      const user = this.$store.getters.user.user_name
      const userId = this.$store.getters.user.id
      this.location = await utils.patrolLocation({ ...this.target, ...this.siteLocation, user, userId, isAdmin: this.isAdmin })
      if (!this.location && !this.isAdmin) {
        this.processing = false
        return
      }

      // 特別仕様のある物件は、ここで「作る報告書」を記録して要る行を作る
      // 「特別仕様のみ」なら特別の行で開き直してから、そのまま開始する
      if (this.specialAvail) {
        const location = this.location
        try {
          const moved = await this.applySpecialChoice()
          if (moved) {
            this.location = location
          }
        } catch (e) {
          console.log(e)
          this.processing = false
          await dialogs.showErrorDialog('エラー', '報告書を作れませんでした。もう一度「開始」を押してください。')
          return
        }
      }

      this.list.start = moment().format('HH:mm')
      this.start = moment().format('HH:mm')
      // 一時保存（特別仕様だけの行は特別仕様の途中保存へ。両方は通常と特別の両方へ）
      if (this.specialMode !== 'only') {
        this.temporarilyRegister('start', null)
      }
      await this.startSpecial()
      this.processing = false
    },

    /**
     * 完了したデータを削除
     */
    // async deleteCompData() {
    //   // 1度でも完了ボタンを押していたら確認ダイアログ出す
    //   if (this.completeBtn || this.undoBtn) {
    //     const canscelR = await dialogs.showConfirmDialog('キャンセル', '完了しているデータも元に戻ります。よろしいでしょうか？')
    //     if (canscelR != 'YES') {
    //       return false

    //     // 途中保存データを削除
    //     } else {
    //       await backend.deleteDataByKey('patrolResult/deleteByPatrolScheduleId', { key: this.target.id, sub: this.$route.query.sub })
    //       this.initData()
    //       this.list = this.target
    //       this.list.today = moment().format('YYYY/MM/DD')
    //       await this.initCheck()
    //       return false
    //     }
    //   }
    //   // まだ1度も完了した項目がなければ、値のみ空にする
    //   return true
    // },

    /**
     * キャンセルボタン
     */
    // async cancelBtn() {
    //   let cancelR = await this.deleteCompData()
    //   if (!cancelR) {
    //     return
    //   }

    //   this.start = ''
    //   this.completeBtn = false
    //   this.checkList.items.forEach(i =>{
    //     if (!i.valueNA) {
    //       i.disabled = false
    //     }
    //     i.complete = false
    //     i.photo = []
    //   })
    // },

    /**
     * 終了ボタン
     */
    async endBtn() {
      // 変更後に再保存していないもの
      let dirty = []
      // 特別仕様だけの行は特別仕様のチェックだけ
      if (this.specialMode === 'only') {
        if (!await this.validateSpecial()) {
          return
        }
        this.end = moment().format('HH:mm')
        await this.allRegister(dirty)
        return
      }
      // すべての値が選択されているか確認
      for (let i = 0; i < this.checkList.items.length; i++) {
        const ci = this.checkList.items[i]
        // 完了済みか確認
        if (!ci.complete) {
          let title = 'No.' + ci.sortNo
          if (ci.classification) {
            title = `【${ci.classification}】`
          }
          await dialogs.showErrorDialog('終了できません', `${title} の完了ボタンが押されていません。`)
          return
        }

        // 写真がない場合
        if (!ci.photo || !ci.photo.length || !ci.photo[0]) {
          await dialogs.showErrorDialog('終了できません', `${'No.' + ci.sortNo} の写真が添付されていません。`)
          return
        }

        let msg = `【${ci.classification}】の`
        if (!ci.classification) {
          msg = `No.${ci.sortNo} の`
        }

        if (!await this.validate(ci, msg)) {
          return
        }
      }
      // 「両方」は特別仕様も全部そろうまで終了できない
      if (this.special && this.canEditSpecial) {
        if (!await this.validateSpecial()) {
          return
        }
      }
      this.end = moment().format('HH:mm')

      await this.allRegister(dirty)
    },

    /**
     * 保存時に必要なデータを生成
     */
    setSaveData() {
      return {
        patrolScheduleId: this.target.id,
        clientCode: this.target.clientCode,
        siteCode: this.target.siteCode,
        completionDate: this.list.today,
        startTime: this.start,
        endTime: this.end,
        location: this.location,
        insertUser: this.$store.getters.user.id
      }
    },

    /**
     * 終了ボタン押下時の最終保存
     */
    async allRegister(dirty) {
      this.processing = true
      this.processingText = '保存中...'
      // RLSから入った場合
      const isRls = this.$route.query.rls

      try {
        let save = this.setSaveData()
        // 特別仕様の結果（両方・特別のみ）。先に保存する＝失敗して押し直しても同じ行を更新するだけで二重にならない
        if (this.special && this.canEditSpecial) {
          await this.completeSpecial()
          this.special.result = { startTime: this.start, endTime: this.end, location: this.location, completionDate: this.list.today }
        }
        // 巡回結果保存（特別仕様だけの行は通常の結果は無い）
        if (this.specialMode !== 'only') {
          await backend.postData('patrolResult/save', { save, item: this.checkList.items, note: [], memo: '', dirty, key: this.target.id, type: this.type, claim: this.claim, spot: false, isRls, rls: this.rls, staff: this.user, getPhoto: 's3Url' })
        }

        this.processing = false

        //ログ出力
        let rls = ''
        if (isRls) {
          rls = 'RLSから'
        }
        let kind = ''
        if (this.specialMode === 'only') {
          kind = '【特別仕様】'
        } else if (this.specialMode === 'both') {
          kind = '【通常＋特別仕様】'
        }
        logManager.recording(this, logManager.Loglevel.INFO, this.typeName, '完了', this.typeName + kind + '（期限日：'+ moment(this.list.termDate).format('YYYY-MM-DD')  + '、担当者：'+ this.list.staff + '、物件名：'+ this.list.siteName +'）を' + rls + '完了しました。')
        this.previous()
        this.initData()
      } catch (err) {
        alert("エラーが発生しました。終了できていません。再度、操作をお願いします。")
        console.log(err)
        this.processing = false
        // 再度、終了ボタンが押せるようにする
        this.end = ''
      }
    },

    /**
     * 一時保存処理
     * @param itemName 変更になった項目
     *   （開始ボタン：start、項目：item、写真：photo、写真削除：deletePhoto)
     * @param val 登録内容
     */
    async temporarilyRegister(itemName, val, event, i, tar) {
      try {
        let save = this.setSaveData()
        let item = null
        let deletePhoto = null

        // 項目
        if (itemName == 'item') {
          item = val
          // 清掃中の場合
          if (event) {
            item = utils.clone(this.checkList.items[i])
            item[tar] = event.val
          }
        // 写真削除
        } else if (itemName == 'deletePhoto') {
          deletePhoto = val
        }
        await backend.postData('patrolResult/temporarily', { save, item, deletePhoto, type: this.type, getPhoto: 's3Url' })
      } catch (err) {
        // 前の画面に戻る
        this.previous()
        this.initData()
      }
    },

    /**
     * 各項目の完了ごとの登録処理
     * @param i 対象項目インデックス
     */
    async register(i) {
      this.processing = true
      this.processingText = '保存中...'

      try {
        let save = this.setSaveData()

        // 完了した対象の項目を保存(値・指摘事項・写真)
        // 写真は撮った瞬間に S3 へ保存済み（期限付き URL で持っている）ので、ここでは写真を送り直さない
        await backend.postData('patrolResult/itemAndNoteSave', { save, item: this.checkList.items[i], memo: '', getPhoto: 's3Url' })

        this.processing = false
      } catch (err) {
        // 前の画面に戻る
        this.previous()
        this.initData()
      }
    },
    /**
     * 写真をドラッグ開始
     */
    async dragStart(row) {
      this.dragItem = row
    },

    /**
     * 写真をドロップ
     */
    async drop(row) {
      if (!this.dragItem || !this.dragItem.sortNo) {
        return
      }

      // 移動しなかった場合
      if (this.dragItem.sortNo == row.sortNo) {
        return
      }

      this.processing = true
      // 移動元
      const moveFrom = utils.clone(this.dragItem)
      // 移動先
      const moveTo = utils.clone(row)

      // 移動先に移動元データを入れる
      row.photo = []
      if (moveFrom.photo && moveFrom.photo[0]) {
        row.photo[0] = moveFrom.photo[0]
      }

      // 移動元に移動先のデータを入れる
      this.dragItem.photo = []
      if (moveTo.photo && moveTo.photo[0]) {
        this.dragItem.photo[0] = moveTo.photo[0]
      }

      const item1 = {
        sortNo: row.sortNo,
        photo: row.photo[0]
      }

      const item2 = {
        sortNo: this.dragItem.sortNo,
        photo: this.dragItem.photo[0],
      }

      const param = {
        item: [item1, item2],
        ...this.setSaveData()
      }
      try {
        await backend.postData('patrolResultPhoto/dropPhoto', param)
      } catch (error) {
        // 前の画面に戻る
        this.previous()
        this.initData()
      }
      this.processing = false
      this.reload++
    },

    /**
     * 写真添付Base64に変換
     * @param i index
     * @param isfolder フォルダボタン押下
     */
    async imageToBase64 (i, event, isfolder) {
      this.processing = true
      // 選択されたファイルの取得
      const file = event.target.files
      this.checkList.items[i].photo = []
      // Base64に変換する
      for (let j = 0; j < file.length; j++) {
        const reader = new FileReader()
        const f = file[j]

        // フォルダーから選択の場合、撮影日時取得
        if (isfolder) {
          const date = await utils.getEXIFDateTimeOriginal(f)
          const check = utils.checkPhotoDate(date)
          if (!check) {
            this.processing = false
            return
          }
        }

        reader.readAsDataURL(f)
        // 変換
        const compressedImage = await new Promise((resolve) => {
          reader.onload = async () => {
            const img = new Image()
            img.src = reader.result

            img.onload = () => {
              const compressedDataUrl = image.compressImage(img, false, 854, 0.8)
              resolve(compressedDataUrl)
            }
          }
        })
        // 即時保存＆保存した写真を返却
        const photo = await this.saveautoPhoto(this.checkList.items[i], compressedImage)
        // 保存に失敗した場合は添付せずに中断する（画面はそのまま残す）
        if (!photo) {
          this.processing = false
          this.reload++
          return
        }
        this.checkList.items[i].photo.push(photo)

        this.processing = false
        this.reload++
      }
    },

    /**
     * 即時保存＆保存した写真の S3 期限付き URL を返却
     * API: patrolResultPhoto/savePhoto
     * @param row 対象行
     * @param base64 写真のbase64
     */
    async saveautoPhoto(row, base64) {
      try {
        // 保存に必要なデータ
        const save = this.setSaveData(null)
        // 写真の番号（添付予定インデックス）
        const idx = row.photo.length
        // 項目のソート番号
        const sortNo = row.sortNo
        const s3Url = await backend.postData('patrolResultPhoto/savePhoto', { save, idx, base64, sortNo, type: this.type })
        return s3Url.data
      } catch (error) {
        // 画面は戻さず、添付だけ失敗として扱う
        // ＊S3へ保存後すぐに取得して表示しているため、一覧に戻って取り直す必要がなくなった
        //   電波の悪い場所で画面を開き直す手間をなくすための対応
        return null
      }
    },

    /**
     * 写真削除
     * @param i 項目インデックス
     * @param j 写真インデックス
     */
    async deletePhoto(i, j) {
      this.processing = true
      this.checkList.items[i].photo.splice(j, 1)
      this.reload++

      // 一時保存
      await this.temporarilyRegister('deletePhoto', { item: this.checkList.items[i], deleteIdx: j })
      this.processing = false
    },

    /**
     * 完了ボタン
     * @param i 対象項目
     */
    async complete(i) {
      if (this.start == '') {
        await dialogs.showErrorDialog('開始ボタン', '開始ボタンを押してください。')
        return
      }

      if (!await this.validate(this.checkList.items[i], '')) {
        return
      }

      this.checkList.items[i].complete = true
      this.undo()
      this.reload++

      // 保存
      this.register(i)
    },

    /**
     * チェック処理
     * @param row 対象データ
     */
    async validate(row, msg) {
      if (!row.classification) {
        await dialogs.showErrorDialog('撮影対象箇所', msg + '撮影対象箇所を入力してください。')
        return false
      }

      if (!row.photo || row.photo.length != 1) {
        await dialogs.showErrorDialog('各項目写真1枚必須', msg + '写真を1枚添付してください。')
        return false
      }
      return true
    },

    /**
     * 完了を表示ボタン
     */
    reDisplay() {
      this.completeBtn = false
      this.undoBtn = true
    },

    /**
     * 完了ボタン押下の状態に戻す
     */
    undo() {
      this.completeBtn = true
      this.undoBtn = false
    },

    /**
     * 前の画面に戻る
     * @param reload リロードなどで URL から開き直したとき（履歴に頼らず、今の履歴を前の画面に置き換える）
     */
    previous(reload) {
      let route = this.routerName
      // RLS 実施画面から開いた場合は RLS 実施画面へ戻るだけ
      // （戻る go(-1) と予定一覧への push を両方すると、push で積んだ分だけ戻り先が報告書にずれて、
      //   リロード時に報告書を何度も開き直す繰り返しになる）
      if (this.$route.query.rls) {
        if (reload || window.history.length <= 1) {
          this.$router.replace({ name: 'RlsForm' })
        } else {
          this.$router.go(-1)
        }
        return
      }
      // 作業完了一覧から来た場合
      if (Number(this.$route.query.sub) == -1) {
        route = 'RoundCheckList'
      }
      // リロードのときは履歴を置き換える（戻るで報告書に戻らないように）
      if (reload) {
        this.$router.replace({ name: route, query: { checkList: 'true' } })
        return
      }
      this.$router.push({
        name: route,
        params: {
          checkListDate: this.target.scheduledDate,
          userId: this.target.userId,
          name: this.target.staff
        },
        query: {
          checkList: 'true'
        }
      })
    },

    /**
     * 過去のフォーマット指定得意先、物件を判断
     */
    isRequireText() {
      if (RLS_OLD_FORMAT.client) {
        // 得意先名で検索
        for (let i = 0; i < RLS_OLD_FORMAT.client.length; i++) {
          const tar = RLS_OLD_FORMAT.client[i]
          if ((this.target.clientName1 + this.target.clientName2).indexOf(tar) > -1) {
            this.textRequire = true
            return
          }
        }
      }

      if (RLS_OLD_FORMAT.site) {
        // 物件名と住所の一部で検索
        for (let i = 0; i < RLS_OLD_FORMAT.site.length; i++) {
          const tar = RLS_OLD_FORMAT.site[i]
          if ((this.target.siteName).indexOf(tar.name) > -1 && (utils.hankaku(this.target.siteAddress)).indexOf(tar.address) > -1) {
            this.textRequire = true
            return
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.mobile-content {
  min-width: 700px;
  padding: 10px;
  -webkit-text-size-adjust: 100%;
}

.pc-content {
  max-width: 800px;
  height: calc(100vh - 20px);
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px;
  border: solid 1px rgb(206, 206, 246);
  border-radius: 10px;
}

.red {
  background: rgb(242, 70, 70);
}

.blue {
  background: rgb(86, 86, 235);
}

.max-w-lg {
  max-width: none !important;
}

.col-no {
  width: 70px;
}

.hover-color:hover {
  color: rgb(11, 118, 200);
}

.bg-orange {
  background-color: rgb(231 137 70);
}

.bg-orange:hover {
  background-color: rgb(239 111 20);
}

.vsa-item {
  background-color: rgb(214, 238, 243);
}

.w-70px {
  width: 70px;
}

/* 特別仕様（清掃前・清掃後） */
.special-tag {
  margin-left: 12px;
  font-size: 12px;
  font-weight: 700;
  color: #9d174d;
  background: #fce7f3;
  padding: 2px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.special {
  width: 92%;
  margin: 24px auto 16px auto;
  padding: 16px 0 8px 0;
  border-top: 3px solid #fbcfe8;
  border-bottom: 3px solid #fbcfe8;
}

/* 両方のときの「通常の報告書」の見出し */
.normal-head {
  width: fit-content;
  margin: 24px auto 0 auto;
  font-size: 22px;
  font-weight: 700;
  color: #1e40af;
}

/* 開始の前の「作る報告書」の切り替え（3 つとも同じ幅） */
.special-choice {
  background: #fdf2f8;
  border: 1px solid #fbcfe8;
  border-radius: 8px;
  padding: 10px 12px;
}

.seg button {
  flex: 1 1 0;
  padding: 10px 4px;
  font-size: 13px;
  font-weight: 700;
  color: #4b5563;
  background: #ffffff;
  border: 1px solid #d1d5db;
  cursor: pointer;
}

.seg button:first-child {
  border-radius: 8px 0 0 8px;
}

.seg button:last-child {
  border-radius: 0 8px 8px 0;
}

.seg button + button {
  border-left: 0;
}

.seg button.seg-on {
  background: #9d174d;
  border-color: #9d174d;
  color: #ffffff;
}

.special-head {
  text-align: center;
  margin-bottom: 20px;
}

.special-title {
  font-size: 22px;
  font-weight: 700;
  color: #9d174d;
}

.special-title-sub {
  margin-left: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #9d174d;
  background: #fce7f3;
  padding: 2px 10px;
  border-radius: 999px;
}

/* 1 箇所のカード */
.special-card {
  width: 560px;
  max-width: 100%;
  margin: 0 14px 28px 14px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.special-card.special-done {
  border-color: #a7f3d0;
  background: #f0fdf4;
}

/* 館銘板のカード（写真 1 枚なので幅を半分に） */
.special-plate {
  width: 300px;
}

.special-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.special-no {
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: #9d174d;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.special-name {
  flex: 1;
  min-width: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  padding: 4px 6px;
  border: 0;
  border-bottom: 2px solid #d1d5db;
  border-radius: 0;
  background: transparent;
}

.special-name:focus {
  outline: none;
  border-bottom-color: #9d174d;
}

.special-name-empty {
  border-bottom-color: #ef4444;
  background: #fef2f2;
}

.special-name-view {
  flex: 1;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.special-check {
  flex: none;
  color: #059669;
}

/* 写真の枠 */
.special-photo {
  height: 240px;
  border-radius: 10px;
  border: 2px dashed #d1d5db;
  background: #f9fafb;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.special-photo.after {
  border-color: #f9a8d4;
  background: #fdf2f8;
}

.special-photo.has-photo {
  border-style: solid;
  border-color: #9ca3af;
  background: #ffffff;
}

.special-photo.after.has-photo {
  border-color: #db2777;
}

.special-kind {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;
  font-size: 13px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 999px;
  background: #4b5563;
  color: #ffffff;
  pointer-events: none;
}

.special-kind.after {
  background: #db2777;
}

.special-empty {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 14px;
  font-weight: 700;
}

.special-empty > * {
  flex: none;
}

/* ひと言 */
.special-note {
  width: 100%;
  margin-top: 12px;
  font-size: 15px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
}

.special-note:focus {
  outline: none;
  border-color: #9d174d;
  background: #ffffff;
}

.special-note.has-note {
  background: #fef9c3;
  border-color: #facc15;
}

.special-note-view {
  margin-top: 8px;
  font-size: 13px;
  padding: 6px 10px;
  border-left: 3px solid #f9a8d4;
  background: #fdf2f8;
  white-space: pre-wrap;
}

.file-type {
  width: 100%;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
}

/* safari用のスタイル */
_::-webkit-full-page-media,
_:future,
:root .file-type {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  position: absolute;
}

.file-type2 {
  width: 49%;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
}

/* safari用のスタイル */
_::-webkit-full-page-media,
_:future,
:root .file-type2 {
  width: 49%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  position: absolute;
}

.file-type3 {
  width: 49%;
  height: 100%;
  /* left: 0; */
  opacity: 0;
  position: absolute;
  top: 0;
}

/* safari用のスタイル */
_::-webkit-full-page-media,
_:future,
:root .file-type3 {
  width: 49%;
  height: 100%;
  top: 0;
  /* left: 0; */
  opacity: 0;
  position: absolute;
}

.mr-73px {
  margin-right: 73px;
}

.bg-darkblue {
  background: #010178;
}

.bg-darkgreen {
  background: #010178;
}

.ml-32p {
  margin-left: 32px;
}

.w-96pa {
  width: 96%;
}

.edit {
  border: 1px solid #053a3a;
}

.p-5p {
  padding: 5px;
}

.p-6p {
  padding: 6px;
}

.w-354 {
  width: 354px;
}

.info1 {
  width: 50%;
}

.info2 {
  width: 50%;
  margin-left: auto;
}

.position-center {
  top: 38%;
  left: 40%;
}

.position-center2 {
  top: 38%;
  /* left: 1%; */
}

.position-center3 {
  top: 38%;
  left: 20%;
}

#classific >>> .v-suggest input {
  color: blue !important;
  font-weight: bold !important;
}

.drag-photo {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
}

@media screen and (max-width: 900px) {
  /* .mobile-content {
    width: 900px !important;
    height: calc(100vh - 90px);
    overflow: auto;
  } */

  .info-group {
    display: block;
  }

  .info1 {
    width: 100%;
  }

  .info2 {
    width: 100%;
    margin-right: auto;
  }

}
</style>